import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Calcolatore from './pages/Calcolatore';
import { Provider } from 'react-redux';
import { createStore } from '@reduxjs/toolkit';
import calcolatoreReducer from './reducer/index';
import axios from "axios";
// import TagManager from 'react-gtm-module';
import { BASENAME } from './constants/SocialTypes';
// import md5 from 'md5-hash';

const store = createStore(
  calcolatoreReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__()
);

const URL_ARRAY = {
  'localhost:3000': 'http://triangolatore.locl/api/v1',
  'fiduciaps.com': 'https://crm.adhocweb.it/api/v1',
};

axios.defaults.baseURL = URL_ARRAY[window.location.host];
axios.defaults.headers.common = {
  'Accept-Language': localStorage.getItem('lang') || 'it',
};

// const tagManagerArgs = {
//   gtmId: 'GTM-5VJR3LZ'
// };

// if (window.location.host === "fiduciaps.com") TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback='Loading...'>
      <BrowserRouter basename={BASENAME[window.location.host]}>
        <Provider store={store}>
          <Routes>
            <Route path="/" element={<Calcolatore />}></Route>
            <Route path="/ps" element={<Calcolatore />}></Route>
            <Route path="/ps/result" element={<Calcolatore />}></Route>
          </Routes>
        </Provider>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();